export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="relative py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#5C5C59] mb-6">
              Bem-vindo ao ANREÁL
            </div>
            <h2 className="font-display text-[36px] sm:text-[44px] lg:text-[56px] leading-[1.05] tracking-[-0.02em] text-[#1A1A1A] text-balance">
              Viva a serenidade
              <br />
              <span className="italic-display text-[#2B3B31]">a passos da cidade.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal" style={{ transitionDelay: "120ms" }}>
            <p className="text-[16px] lg:text-[18px] leading-[1.7] text-[#1A1A1A]/80 font-light text-pretty">
              Mais do que um espaço para morar, o <span className="text-[#1A1A1A]">ANREÁL Residence</span> é um lugar para viver com presença e significado. Um refúgio no coração de Cantanhede, onde o tempo abranda e cada detalhe foi pensado para que se sinta verdadeiramente em casa.
            </p>
            <div className="mt-10 pt-8 border-t border-[#E5E5DF] grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div>
                <div className="text-[11px] tracking-[0.28em] uppercase text-[#5C5C59] mb-2">Condomínio Privado</div>
                <div className="font-display text-xl text-[#1A1A1A]">Cantanhede, Coimbra</div>
              </div>
              <div>
                <div className="text-[11px] tracking-[0.28em] uppercase text-[#5C5C59] mb-2">Envolvente</div>
                <div className="font-display text-xl text-[#1A1A1A]">4 000m² de jardim privado</div>
              </div>
            </div>
            <p className="mt-8 text-[15px] leading-relaxed text-[#5C5C59] font-light">
              Acesso direto à A17 e A14, entre Coimbra, Aveiro e Figueira da Foz. Uma localização estratégica para viver — ou investir.
            </p>
          </div>
        </div>

        <div className="mt-16 lg:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 reveal" style={{ transitionDelay: "200ms" }}>
          <div className="lg:col-span-8 image-zoom border border-[#E5E5DF]">
            <img
              src="/images/vista-aerea-piscina.webp"
              alt="Vista aérea — Jardins e piscina"
              className="w-full h-[320px] sm:h-[460px] lg:h-[560px] object-cover"
            />
          </div>
          <div className="lg:col-span-4 flex flex-col justify-end">
            <div className="bg-[#E5E5DF]/60 border border-[#E5E5DF] p-8 lg:p-10">
              <div className="text-[11px] tracking-[0.28em] uppercase text-[#5C5C59] mb-4">Vista Aérea</div>
              <p className="font-display text-2xl lg:text-3xl text-[#1A1A1A] leading-snug">
                Três blocos. Uma identidade. Uma forma de viver.
              </p>
              <p className="mt-5 text-[14px] text-[#5C5C59] leading-relaxed">
                Jardins privativos, piscina, court de padel e 66 lugares de estacionamento subterrâneo com pré-instalação para carregamento elétrico.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
